module.exports = __webpack_public_path__ + "static/media/internet.d61fe586.svg";